import React from "react";
import { IconButton, Input } from "rsuite";
import { typeTravler } from "../../../../Constants/types";
import styles from "./styles/tableStyles";
import TrashIcon from "@rsuite/icons/Trash";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import Translation from "../../../../translation/translation";

const PricesPackageTable = ({
  onPriceChange,
  onDeletePrice,
  onAddPrice,
  prices,
}) => {
  return (
    <div>
      <table>
        <thead style={styles.thead}>
          <tr>
            <th style={styles.th}>{Translation.hotel}</th>
            <th style={styles.th}>Nom de l'arrangement</th>
            {typeTravler.map((traveler) => (
              <th key={traveler.value} style={styles.th}>
                {traveler.label}
              </th>
            ))}
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(prices).map(([hotelName, roomGroups]) =>
            Object.entries(roomGroups).map(
              ([arrangementName, roomPrices], index) => (
                <tr key={`${hotelName}-${arrangementName}-${index}`}>
                  <td style={styles.td}>
                    <h6>{hotelName}</h6>
                  </td>
                  <td style={styles.td}>
                    <Input disabled={true} value={arrangementName} />
                  </td>
                  {typeTravler.map((traveler) => {
                    const travelerPrice =
                      roomPrices.find(
                        (price) => price.typeTraveler === traveler.value
                      )?.price || 0;

                    return (
                      <td key={traveler.value} style={styles.td}>
                        <Input
                          value={travelerPrice}
                          onChange={(priceValue) =>
                            onPriceChange(
                              hotelName,
                              arrangementName,
                              traveler.value,
                              "price",
                              parseFloat(priceValue)
                            )
                          }
                        />
                      </td>
                    );
                  })}
                  <td style={styles.td}>
                    <IconButton
                      onClick={() => onDeletePrice(hotelName, arrangementName)}
                      color="violet"
                      icon={<TrashIcon />}
                    />
                    {index === Object.entries(roomGroups).length - 1 &&
                      Object.entries(roomGroups).length < 6 && (
                        <IconButton
                          onClick={() => onAddPrice(hotelName)}
                          color="violet"
                          icon={<PlusRoundIcon />}
                        />
                      )}
                  </td>
                </tr>
              )
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PricesPackageTable;
